import React from 'react';
import { BarChart3Icon, ClipboardListIcon, ShieldIcon, SwordsIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { playbookFeatures } from '../data/content';
const icons = {
  offense: SwordsIcon,
  defense: ShieldIcon,
  drills: ClipboardListIcon,
  charts: BarChart3Icon
};
export function PlaybookSpotlight() {
  return <section className="w-full bg-ink px-5 py-20 text-white sm:px-8" data-id="element-118" data-mp="3ijlwq4ziffds">
      <div className="mx-auto w-full max-w-5xl" data-id="element-119" data-mp="3ngcdyvn1wh0s">
        <Reveal data-id="element-120" data-mp="3njqdzx88se52">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight sm:text-4xl md:text-5xl" data-id="element-121" data-mp="3ripixhtz4awi">
            Complete <span className="text-brand" data-id="element-122" data-mp="dpqbytct62m">Playbook System</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-center text-base text-white/65 sm:text-lg" data-id="element-123" data-mp="5biy2wab2850">
            Offense and defense that grow with your players.
          </p>
        </Reveal>

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4" data-id="element-124" data-mp="2734eb8sqzda5">
          {playbookFeatures.map((feature, index) => {
          const Icon = icons[feature.icon as keyof typeof icons];
          return <Reveal key={feature.title} delay={index * 0.04} className="h-full" data-id="element-125" data-mp="24glm8qgcq9ol" data-mpi={index}>
                <li className="flex h-full flex-col gap-4 rounded-card border border-white/10 bg-surface p-5 sm:p-6" data-id="element-126" data-mp="1zi0mst8xbu17">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand/15" data-id="element-127" data-mp="1vgyrgni4o24i">
                    <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-128" data-mp="2s6y1kmdxf8p7" />
                  </span>
                  <span className="font-display text-base font-bold leading-snug" data-id="element-129" data-mp="2n7d3ee6kz4dj">
                    {feature.title}
                  </span>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}